<template>
    <div class="card">

        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                :showAddNew="true"
                title="Bank Branches"
                btnTitle="Add new"
                @onClickAddNewButton="onClickAddNew"
            />
        </div>

        <!-- TODO: Filters will be added -->
        <div class="my-2 px-2">
            
        </div>

        <div class="col-12 px-2 mt-2 mb-4">
            <ListTable
                :tableItems="tableItems"
                @onEditSR="onEditSR"
            />
        </div>

        <div class="px-2 position-absolute bottom-0 mt-4">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
        </div>

        <Loader v-if="loading"/>

        <AddOrEditDealer
            v-if="store.state.isModalOpen"
            :noteStatus="noteStatus"
            :editData="editData"
            @onSubmit="onSubmit"
        />

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import AddOrEditDealer from '@/components/molecule/company/crm/dealer/AddOrEditDealerModal.vue';
import ListTable from '@/components/molecule/company/crm/dealer/DealerTable.vue';
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleCrm from '@/services/modules/crm/crm.js'

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const params = reactive({
    searchTxt: '',
    offset: 10
});
const editData = ref(null);
const noteStatus = reactive([
    {
        value: 'active',
        name: 'Active',
    },
    {
        value: 'inactive',
        name: 'Inactive'
    }
])

const { fetchDealerList, fetchSingleDealer } = handleCrm();

const onClickAddNew = () => {
    editData.value = null;
    store.state.isModalOpen = true;
}

const setPaginationData = (data) => {
    store.commit('setPaginationData', data)
};

const onSubmit = () => {
    getDealerList();
}

const onEditSR = async (item) => {
    const query = getQuery();
    await fetchSingleDealer(query, item.id).then((res) => {

        if(!res.status) return showError(res.message);

        editData.value = res.data;
        store.state.isModalOpen = true;
    })
}

const setPagination = (data) => {
    setPaginationData({
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

async function onPageChange(page) {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    router.push({path: route.path, query: routeQuery})
    await getDealerList();
}

const getDealerList = async () => {
    const query = getQuery();
    loading.value = true

    await fetchDealerList(query).then(res => {
        loading.value = false
        if (!res.status){
            store.commit("resetPagination")
            return
        }
        tableItems.value = res.data.data;
        setPagination(res.data)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (route.query.page) query += '&page=' + route.query.page
    if(params.searchTxt) query += `&search_txt=${params.searchTxt}`;
    query += '&offset=' + params.offset
    return query;
}

onMounted(async () => {
    await getDealerList()
})
</script>

<style scoped>

</style>